/**
 * src/features/auth/lib/passwordPolicy.ts
 *
 * Single client-side mirror of the server's minPasswordLength: 8
 * (functions/lib/auth.ts, Phase 40). This is a client-side UX guard against an empty
 * round-trip only — the server remains the source of truth. If this number ever drifts
 * from the server's, a form built on it would submit a password the server is guaranteed
 * to reject (CLAUDE.md rule 9 — named constant with rationale).
 *
 * Extracted from PasswordSignInForm.tsx (Phase 42) because Phase 43 introduces two more
 * password fields (ResetPasswordPage, and later SecuritySettingsCard) that need the exact
 * same number — three drifting copies of a server-mirrored constant is what this module
 * exists to prevent.
 */
export const MIN_PASSWORD_LENGTH = 8;
